import React from 'react';
import { ConfigProvider } from 'antd';
import { useTheme } from './ThemeContext';

interface Props {
    children: React.ReactNode;
}

export const ThemedConfigProvider = ({ children }: Props) => {
    const { theme } = useTheme();

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorBorder: theme.semantic.border,
                    colorBorderSecondary: theme.semantic.border,
                    colorPrimaryBorder: theme.semantic.border,
                    colorPrimaryBorderHover: theme.semantic.border,
                    colorPrimaryHover: theme.semantic.border,
                    colorPrimary: theme.semantic.border,
                    controlOutline: theme.semantic.border,
                    colorText: theme.semantic.textPrimary,
                    colorTextPlaceholder: theme.semantic.neutral,
                    colorTextDisabled: theme.semantic.textDisabled,
                    colorBgElevated: theme.semantic.surface,
                    colorIcon: theme.semantic.onBackground,
                    colorIconHover: theme.semantic.primaryHover,
                    colorFillContent: theme.semantic.skeleton,
                    colorFillAlter: theme.semantic.surface,
                    colorFillContentHover: theme.semantic.skeleton,
                    colorTextDescription: theme.semantic.neutral,
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};
